<template>
  <div class="content-box">
    <div class="content">
      <div class="title-box">
        <span class="title">等级测试报名</span>
      </div>
      <div class="test-name">
        <span>{{ listMatches[listMatches.length - 1].name }}</span>
      </div>

      <div v-for="(firstItem, index) in firstClass">
        <template>
          <div class="table-box">
            <div class="search-box">
              <el-form :inline="true" size="mini">
                <el-form-item label="报名类别选择">
                  <el-cascader
                    :options="options"
                    style="width: 350px"
                    :ref="index"
                    v-model="firstItem.form.value"
                    @change="handleChange($event, index)"
                  >
                  </el-cascader>
                </el-form-item>

                <el-form-item style="float: right">
                  <el-button
                    style="background: #5a5cbb; border: none; color: #fff"
                    icon="el-icon-plus"
                    @click="addType(index)"
                    >新增类别</el-button
                  >
                  <el-button
                    style="background: #5a5cbb; border: none; color: #fff"
                    :disabled="firstClass.length == 1"
                    icon="el-icon-delete"
                    @click="deleteType(index)"
                    type="primary"
                    >删除报名</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
            <div class="table-content">
              <el-form
                size="mini"
                :model="firstItem"
                :ref="'ruleForm' + index"
                v-if="nicai"
              >
                <el-table
                  :data="firstItem.tableData"
                  size="mini"
                  :span-method="
                    firstItem.form.value[1] &&
                    firstItem.form.value[1].indexOf('冰上舞蹈') != -1
                      ? objectSpanMethod
                      : notSpanMethod
                  "
                  border
                  style="width: 100%"
                >
                  <el-table-column
                    label="编号"
                    type="index"
                    align="center"
                    color="#fff"
                    width="50"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="address"
                    label="证件号(必填)"
                    width="175"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-form-item
                        style="margin-bottom: 0"
                        :prop="
                          'tableData.' + scope.$index + '.personIdcodeInfo'
                        "
                        :rules="[
                          { required: true, message: ' ', trigger: 'blur' },
                          {
                            validator: rules.validateCredentialsNo,
                            trigger: 'blur',
                          },
                        ]"
                      >
                        <el-autocomplete
                          :disabled="
                            roleType === RoleType.Personal && scope.$index == 0
                          "
                          v-model="scope.row.personIdcodeInfo"
                          :fetch-suggestions="querySearch"
                          :debounce="1500"
                          placeholder="请输入证件号"
                          :select-when-unmatched="true"
                          :trigger-on-focus="true"
                          @focus="getIndex(index, scope.$index)"
                          @select="handleSelect"
                        ></el-autocomplete>
                        <!--<el-input :disabled="firstItem.editOrNot&&scope.row.perAllow" v-model="scope.row.personIdcodeInfo"  placeholder="请输入身份证"></el-input>-->
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="姓名(必填)"
                    width="120"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-form-item
                        style="margin-bottom: 0"
                        :prop="'tableData.' + scope.$index + '.personNameInfo'"
                        :rules="[
                          { required: true, message: ' ', trigger: 'blur' },
                        ]"
                      >
                        <el-input
                          :disabled="
                            scope.row.notAllowChange ||
                            (roleType === RoleType.Personal &&
                              scope.$index == 0)
                          "
                          v-model="scope.row.personNameInfo"
                          placeholder="请输入姓名"
                        ></el-input>
                        <!--<el-autocomplete-->
                        <!--:disabled="roleType=='3'"-->
                        <!--v-model="scope.row.personNameInfo"-->
                        <!--:fetch-suggestions="querySearch"-->
                        <!--placeholder="请输入名称"-->
                        <!--:trigger-on-focus="true"-->
                        <!--@focus="getIndex(index,scope.$index)"-->
                        <!--@select="handleSelect"-->
                        <!--:readonly="isReadonly"-->
                        <!--&gt;</el-autocomplete>-->
                      </el-form-item>
                    </template>
                  </el-table-column>

                  <el-table-column
                    label="性别(必填)"
                    width="110"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-form-item
                        style="margin-bottom: 0"
                        :prop="'tableData.' + scope.$index + '.genderInfo'"
                        :rules="[
                          { required: true, message: ' ', trigger: 'blur' },
                        ]"
                      >
                        <!--<el-select :disabled="firstItem.editOrNot&&scope.row.genderInfollow" v-model="scope.row.genderInfo" placeholder="请选择">-->
                        <el-select
                          :disabled="
                            scope.row.notAllowChange ||
                            (roleType === RoleType.Personal &&
                              scope.$index == 0)
                          "
                          v-model="scope.row.genderInfo"
                          placeholder="请选择"
                        >
                          <el-option label="男" value="1"></el-option>
                          <el-option label="女" value="2"></el-option>
                        </el-select>
                      </el-form-item>
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="credentialsTypeInfo"
                    label="证件类型(必填)"
                    width="120"
                    align="center"
                  >
                    >
                    <template slot-scope="scope">
                      <el-form-item
                        style="margin-bottom: 0"
                        :prop="
                          'tableData.' + scope.$index + '.credentialsTypeInfo'
                        "
                        :rules="[
                          { required: true, message: ' ', trigger: 'blur' },
                        ]"
                      >
                        <!--<el-select  v-model="scope.row.credentialsTypeInfo" placeholder="请选择">-->
                        <el-select
                          :disabled="
                            scope.row.notAllowChange ||
                            (roleType === RoleType.Personal &&
                              scope.$index == 0)
                          "
                          v-model="scope.row.credentialsTypeInfo"
                          placeholder="请选择"
                        >
                          <!--<el-select :disabled="firstItem.editOrNot&&scope.row.TypeInfo" v-model="scope.row.credentialsTypeInfo" placeholder="请选择">-->
                          <el-option label="身份证" value="1"></el-option>
                          <el-option label="护照" value="2"></el-option>
                          <!-- <el-option label="户口本" value="3"></el-option> -->
                        </el-select>
                      </el-form-item>
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="birthday"
                    label="出生日期(必填)"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-form-item
                        style="margin-bottom: 0"
                        :prop="'tableData.' + scope.$index + '.birthday'"
                        :rules="[
                          { required: true, message: ' ', trigger: 'change' },
                        ]"
                      >
                        <el-date-picker
                          prefix-icon="birthday-icon"
                          v-model="scope.row.birthday"
                          type="date"
                          :disabled="!scope.row.canUpdateBirthday"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          style="width: 100%"
                          placeholder="请输入出生日期"
                          popper-class="date-style"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="coachName"
                    label="教练姓名(必填)"
                    align="center"
                    :width="`${roleType !== RoleType.Personal ? 140 : 'auto'}`"
                  >
                    <template slot-scope="scope">
                      <el-form-item
                        style="margin-bottom: 0"
                        :prop="'tableData.' + scope.$index + '.coachName'"
                        :rules="[
                          { required: true, message: ' ', trigger: 'blur' },
                        ]"
                      >
                        <el-input
                          v-model="scope.row.coachName"
                          placeholder="请输入教练姓名"
                        ></el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="coachTel"
                    label="教练手机号(必填)"
                    align="center"
                    :width="`${roleType !== RoleType.Personal ? 160 : 'auto'}`"
                  >
                    <template slot-scope="scope">
                      <el-form-item
                        style="margin-bottom: 0"
                        :prop="'tableData.' + scope.$index + '.coachTel'"
                        :rules="[
                          { required: true, message: ' ', trigger: 'blur' },
                          {
                            validator: rules.coachTel,
                            trigger: 'blur',
                          },
                        ]"
                      >
                        <el-input
                          v-model="scope.row.coachTel"
                          placeholder="请输入教练手机号"
                        ></el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>

                  <el-table-column
                    label="操作"
                    width="210"
                    align="center"
                    v-if="roleType !== RoleType.Personal"
                  >
                    <template slot-scope="scope">
                      <el-form-item style="margin-bottom: 0">
                        <el-button
                          size="small"
                          style="padding: 7px 15px"
                          @click="addPlayer(index, scope.$index)"
                          icon="el-icon-plus"
                          >添加人员</el-button
                        >
                        <el-button
                          type="danger"
                          style="padding: 7px 15px"
                          :disabled="
                            firstItem.typesData === '冰上舞蹈'
                              ? firstItem.tableData.length === 2
                              : firstItem.tableData.length === 1
                          "
                          @click="deletePlayer(index, scope.$index)"
                          size="small"
                          icon="el-icon-delete"
                          >删除</el-button
                        >
                      </el-form-item>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="submit-box">
      <div class="submit-content-box">
        <button
          @click="lookTips"
          :style="{
            cursor: roleType === RoleType.Visitor ? 'no-drop' : 'pointer',
          }"
          :title="roleType === RoleType.Visitor ? '完善信息' : ''"
        >
          立即报名
        </button>
      </div>
    </div>
    <!-- 报名要求弹窗 温馨提示 -->
    <el-dialog title="温馨提示" :visible.sync="dialogVisible" width="60%">
      <div style="line-height: 1.6">
        <p style="font-size: 18px">等级测试报名要求</p>
        <p style="color: red">
          （充分阅读并了解报名规则后才能报名，如未按要求进行报名，后果自行承担）
        </p>
        <p>&nbsp;</p>
        <p style="margin-bottom: 5px">
          1. 年满22周岁首次参加测试者，只可参加成人自由滑等级测试项目。
        </p>
        <p style="margin-bottom: 5px">
          2. 单人滑等级测试通过步法表演节目3级者，方可参加冰上舞蹈等级测试。
        </p>
        <p style="margin-bottom: 5px">
          3.
          首次参加测试的人员必须从1级开始（单人滑步法表演节目必须从基础级开始）逐级进行测试，不允许越级测试。只有通过了项目的某一级别测试后，方可报名参加更高一级的测试。（如：通过步法表演节目一级后，方可报考步法表演节目二级）因特殊原因需要越级参加测试的人员（如：境外长期训练者、境外参加国际比赛成绩优异者，须持有国际滑联各类成年、青少年比赛成绩证明，经中国花样滑冰协会批准方可参加测试）。
        </p>
        <p style="margin-bottom: 5px">
          4.
          等级测试单人滑分为两项：步法表演节目、自由滑，两项分开计算并分别获得证书。测试者可单独参加基础级-10级的步法表演节目测试并获得相应证书，也可单独参加1-10级自由滑测试并获得相应证书。
        </p>
        <p style="margin-bottom: 5px">
          5.
          每个级别的自由滑/冰上舞蹈，测试前分组热身5分钟，步法表演节目测试前分组热身3分钟，不播放音乐。
        </p>
        <p style="margin-bottom: 5px">
          6.
          参加等级测试的人员提交报名信息后须在十五分钟内缴纳测试费用，未在规定时间内缴纳报名费将自动删除订单及其报名信息，仅有完成缴费报名成功的人员可参加等级测试。
        </p>
        <p style="margin-bottom: 5px">
          7.
          具体报名要求以官网报名通知为准。提交报名信息时，请仔细核查报名信息，确保内容准确详实。如自身填写提交内容错误、报名缴费不成功等问题影响测试测试及成绩，造成的一切后果自行承担，且报名费不予退回。
        </p>
        <p style="margin-bottom: 5px">
          8. 等级测试收费标准： <br />
          &nbsp;&nbsp;&nbsp;&nbsp;（1）二级及以下每人每项200元<br />
          &nbsp;&nbsp;&nbsp;&nbsp;（2）三级至六级每人每项300元<br />
          &nbsp;&nbsp;&nbsp;&nbsp;（3）七级至十级每人每项400元
        </p>
      </div>
      <div style="margin-top: 30px; text-align: center">
        <el-checkbox v-model="checked">已充分阅读并了解报名规则</el-checkbox>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="cancelApply"> 取消报名 </el-button>
        <el-button v-loading="loading" type="primary" @click="savePlayer">
          同意
        </el-button>
      </span>
    </el-dialog>
    <!-- 授权声明弹窗 -->
    <el-dialog
      class="auth-dialog"
      :visible.sync="authDialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
      width="42%"
    >
      <div class="auth-statement">
        <h2>中国花样滑冰协会赛事、训练营、培训等活动参与者授权声明</h2>
        <p>1.同意遵守活动规程、通知、手册等相关要求；</p>
        <p>
          2.授权并同意中国花样滑冰协会对本人进行拍摄，且中国花样滑冰协会有权自行或授权第三方无偿使用本人提供的或在活动过程中形成的包含本人肖像、姓名、声音等的图片、视频等视听资料，并进一步在全国及世界范围内进行展示和传播，以推广花样滑冰运动；
        </p>
        <p>3.同意放弃对中国花样滑冰协会使用上述视听资料的一切追诉权利；</p>
        <p>4.确保本人符合活动的参与资格；</p>
        <p>
          5.声明并保证，本人参加上述活动期间使用和展示的音乐和编舞已经过许可和授权，可面向公众使用。本人确保现场使用及拍摄后在全国及世界各地的电视和其他媒体上播放和重播，无需中国花样滑冰协会或相关播放平台进一步取得许可或支付任何费用；
        </p>
        <p>
          6.理解并将遵守活动关于商标露出、赞助商权益等相关规定，包括但不限于在活动采访、颁奖仪式等环节遵守相关规定；
        </p>
        <p>
          7.授权并同意在活动期间进行的中国花样滑冰协会批准的研究项目中收集和使用本人个人数据和统计资料（例如，运动员测量、视频采集、问卷等）。
        </p>
        <p>
          <em
            >本人授权并同意以上述方式使用和处理本人的授权内容，本声明长期有效。</em
          >
        </p>
        <p>
          <em
            >因违反本声明造成的一切法律后果由本人承担，且本人将赔偿由此给中国花样滑冰协会造成的一切损失。</em
          >
        </p>
        <div class="checkbox">
          <el-checkbox v-model="authChecked">
            {{ authCheckboxText }}
          </el-checkbox>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :disabled="!authChecked"
          @click="authDialogVisible = false"
          >确认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
var qs = require("qs");
import { get, post } from "@/api/fetch.js";
import url from "@/api/serviceAPI.config.js";

export default {
  name: "",
  data() {
    const RoleType = {
      Club: "1",
      Personal: "3",
      Visitor: "4",
    };
    return {
      token: sessionStorage.getItem("ACCESS_TOKEN"),
      loading: false,
      RoleType,
      authDialogVisible: false,
      authChecked: false,
      orgId: "",
      roleType: "",
      timer: null,
      clubName: "",
      matchId: 3,
      stationData: [], //分站
      allowApply: "",
      options: [],
      sendData: [],
      sendBWData: [],
      libraryData: [
        {
          personIdcodeInfo: "34564575678568679",
          personNameInfo: "李中胡",
          genderInfo: "1",
          credentialsTypeInfo: "2",
        },
      ],
      firstClass: [
        {
          typesData: "", //类别
          classData: "",
          editOrNot: true,
          form: {
            arrangementId: "",
            value: [],
          },
          tableData: [
            {
              personIdcodeInfo: "",
              perAllow: true,
              personNameInfo: "",
              genderInfo: "",
              credentialsTypeInfo: "",
              substationNameInfo: "",
              levelCategoryNameInfo: "",
              testLevelNameInfo: "",
              orgId: JSON.parse(sessionStorage.getItem("userId")),
              matchId: 3,
              birthday: "",
              notAllowChange: true,
            },
          ],
          name: "",
        },
      ],
      listMatches: [{ name: "" }],
      dialogVisible: false,
      checked: false,
      result: [],
      nicai: true,
      rules: {
        coachTel: (rule, value, callback) => {
          if (!/^(1+\d{10})$/.test(value)) {
            this.$message.error("请输入正确的手机号");
            callback(new Error(" "));
          } else {
            callback();
          }
        },
        validateCredentialsNo: (rule, value, callback) => {
          if (value == "") {
            callback(new Error(" "));
          } else if (/\s/g.test(value)) {
            this.$message.error("请勿输入空格");
            callback(new Error(" "));
          } else if (!/^[0-9a-zA-Z()]+$/.test(value)) {
            this.$message.error("只能输入数字和字母及英文小括号");
            callback(new Error(" "));
          } else {
            callback();
          }
        },
      },
      // isReadonly:true
      // 报名成功返回
      signUpVal: {},
    };
  },
  computed: {
    authCheckboxText() {
      return JSON.parse(window.sessionStorage.getItem("user")).type == "3"
        ? "本人及其监护人同意授权，勾选此项视为本人及监护人已签字"
        : "已征得本人及其监护人授权，勾选此项视为本人及监护人已签字";
    },
  },
  created() {
    this.getUserMsg();
    setTimeout(() => {
      this.authDialogVisible = true;
    }, 800);
  },
  methods: {
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 8) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    notSpanMethod() {
      return {
        rowspan: 1,
        colspan: 1,
      };
    },
    lookTips() {
      this.dialogVisible = true;
    },
    // 取消报名
    cancelApply() {
      this.dialogVisible = false;
      this.loading = false;
    },
    // 同意报名
    savePlayer() {
      clearTimeout(this.timer);

      if (this.roleType === this.RoleType.Visitor || !this.allowApply) {
        this.timer = setTimeout(() => {
          this.$notify({
            title: "请完善个人信息",
            message: "报名前请完善用户信息！",
            duration: 3000,
            type: "error",
            onClose: () => {
              return false;
            },
          });
        }, 500);
        return;
      }

      if (!this.checked) {
        this.timer = setTimeout(() => {
          this.$notify({
            title: "注意",
            message:
              "请充分阅读并了解报名规则后再勾选‘已充分阅读并了解报名规则’后进行报名",
            duration: 3000,
            type: "warning",
            onClose: () => {
              return false;
            },
          });
        }, 500);
        return;
      }
      if (!this.loading) {
        this.loading = true;

        this.timer = setTimeout(() => {
          let newArr = [];

          let checkForm = (formName) => {
            let result = new Promise((resolve, reject) => {
              this.$refs[formName][0].validate((valid, object) => {
                if (valid) {
                  resolve();
                } else {
                  this.timer = setTimeout(() => {
                    this.$notify({
                      title: "注意",
                      message: "存在必填项未填，请检查后再进行报名",
                      duration: 3000,
                      type: "warning",
                      onClose: () => {
                        return false;
                      },
                    });
                  }, 500);
                  reject();
                }
              });
            });
            newArr.push(result);
          };

          this.firstClass.forEach((item, index) => {
            checkForm("ruleForm" + index); //校验
          });
          Promise.all(newArr)
            .then(() => {
              return this.sendDataDeal();
            })
            .then((res) => {
              let { sendBWData, sendData } = res;
              if (this.sendData.length) this.saveOther(sendData);
              if (this.sendBWData.length) this.saveBw(sendBWData);
            })
            .catch((err) => {
              console.log("report err");
            })
            .finally(() => {
              // this.loading = false;
            });
        }, 500);
      }
    },
    sendDataDeal() {
      return new Promise((resolve, reject) => {
        this.sendData = []; //非冰舞
        this.sendBWData = []; //冰舞
        let sendBWData = [],
          sendData;
        for (let item of this.firstClass) {
          if (item.form.value[1].indexOf("冰上舞蹈") != -1) {
            sendBWData = [...sendBWData, ...item.tableData];
          } else {
            this.sendData = this.sendData.concat(item.tableData);
          }
        }
        console.log(sendBWData);
        for (let i = 0; i < sendBWData.length / 2; i++) {
          this.sendBWData.push([sendBWData[i * 2], sendBWData[i * 2 + 1]]);
        }
        console.log(this.sendBWData);
        sendData = JSON.stringify(this.sendData);
        sendBWData = JSON.stringify(this.sendBWData);
        resolve({ sendData, sendBWData });
      });
    },
    saveBw(sendBWData) {
      // 创建实例时设置配置的默认值
      var instance = axios.create();
      // 在实例已创建后修改默认值
      instance.defaults.headers.post["Content-Type"] = "application/json";
      if (this.token) instance.defaults.headers.token = this.token;
      instance
        .post(url.putIcRegistrationInfo, sendBWData)
        .then((result) => {
          if (result.data.status == 200) {
            this.dialogVisible = false;
            this.signUpVal = {
              arrangementId: result.data.arrangementIds
                ? result.data.arrangementIds.join(",")
                : null,
              matchId: result.data.matchId || null,
              registrationInfoId: result.data.registrationInfoId
                ? result.data.registrationInfoId.join(",")
                : null,
              id: JSON.parse(sessionStorage.getItem("userId")) || null,
              createType: JSON.parse(sessionStorage.getItem("type")) || null,
            };
            this.jumpPayWay();
            this.$notify({
              title: "报名成功",
              message: result.data.message,
              duration: 3000,
              type: "success",
              onClose: () => {
                // this.jumpPayWay();
                // this.$router.push({ path: "classStatus" });
              },
            });
          } else {
            this.loading = false;
            this.$notify({
              title: "报名失败",
              duration: 3000,
              message: result.data.data[0],
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    saveOther(saveOther) {
      console.log(saveOther);
      // 创建实例时设置配置的默认值
      var instance = axios.create();
      // 在实例已创建后修改默认值
      instance.defaults.headers.post["Content-Type"] = "application/json";
      if (this.token) instance.defaults.headers.token = this.token;
      instance
        .post(url.savePlayer, saveOther)
        .then((result) => {
          if (result.data.status == 200) {
            this.dialogVisible = false;
            this.signUpVal = {
              arrangementId: result.data.arrangementIds
                ? result.data.arrangementIds.join(",")
                : null,
              matchId: result.data.matchId || null,
              registrationInfoId: result.data.registrationInfoId
                ? result.data.registrationInfoId.join(",")
                : null,
              id: JSON.parse(sessionStorage.getItem("userId")) || null,
              createType: JSON.parse(sessionStorage.getItem("type")) || null,
            };
            this.jumpPayWay();
            this.$notify({
              title: "保存成功",
              message: result.data.message,
              duration: 3000,
              type: "success",
              onClose: () => {
                // this.jumpPayWay();
                // this.$router.push({ path: "classStatus" });
              },
            });
          } else {
            this.loading = false;
            this.$notify({
              title: "保存失败",
              duration: result.data.data[0].includes("初次报名22周岁以上")
                ? 5000
                : 3000,
              message: result.data.data[0],
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getGameLists() {
      post(url.listMatche).then((res) => {
        this.listMatches = res.data;
        this.getSelect(this.roleType, 0);
      });
    },
    addType(index) {
      /*this.firstClass.push(newObj)*/
      this.firstClass.splice(index + 1, 0, {
        typesData: [], //类别
        editOrNot: true,
        classData: [],
        form: {
          arrangementId: "",
          value: [],
        },
        tableData: [
          {
            personIdcodeInfo: "",
            personNameInfo: "",
            genderInfo: "",
            credentialsTypeInfo: "",
            orgId: this.orgId,
            matchId: this.listMatches[this.listMatches.length - 1].id,
            birthday: "",
            notAllowChange: true,
          },
        ],
      });
      /*this.getSelect(this.roleType,index+1);*/
    },
    deleteType(index) {
      this.firstClass.splice(index, 1);
    },
    addPlayer(typeindex, listindex) {
      let { tableData, form } = this.firstClass[typeindex];
      if (!form.value.length) {
        //是否选择类别
        this.$message.warning("请先选择类别");
        return false;
      }
      if (form.value[1].indexOf("冰上舞蹈") != -1) {
        //如果是冰舞，新增增加两行
        tableData.splice(
          listindex + 2,
          0,
          {
            personIdcodeInfo: "",
            personNameInfo: "",
            genderInfo: "",
            credentialsTypeInfo: "",
            orgId: this.orgId,
            matchId: this.listMatches[this.listMatches.length - 1].id,
            arrangementId: form.arrangementId,
            orgName: this.clubName,
            birthday: "",
            notAllowChange: true,
          },
          {
            personIdcodeInfo: "",
            personNameInfo: "",
            genderInfo: "",
            credentialsTypeInfo: "",
            orgId: this.orgId,
            matchId: this.listMatches[this.listMatches.length - 1].id,
            arrangementId: form.arrangementId,
            orgName: this.clubName,
            birthday: "",
            notAllowChange: true,
          }
        );
      } else {
        tableData.splice(listindex + 1, 0, {
          personIdcodeInfo: "",
          personNameInfo: "",
          genderInfo: "",
          credentialsTypeInfo: "",
          orgId: this.orgId,
          matchId: this.listMatches[this.listMatches.length - 1].id,
          arrangementId: form.arrangementId,
          orgName: this.clubName,
          birthday: this.birthday,
          notAllowChange: true,
        });
      }
    },
    deletePlayer(typeindex, listindex) {
      if (this.firstClass[typeindex].typesData === "冰上舞蹈") {
        this.firstClass[typeindex].tableData.splice(listindex, 2);
      } else {
        this.firstClass[typeindex].tableData.splice(listindex, 1);
      }
    },
    getSelect(type, index) {
      post(
        url.getSelect,
        type === this.RoleType.Personal
          ? {
              id: this.listMatches[this.listMatches.length - 1].id,
              personId: this.orgId,
            }
          : { id: this.listMatches[this.listMatches.length - 1].id }
      ).then((res) => {
        let options = res.value.children;
        // ✅ 只倒序 二级目录（核心代码）
        options.forEach((level1) => {
          // 如果一级下面有children（二级），就反转二级
          if (level1.children && level1.children.length) {
            // 不修改原数组，安全倒序
            level1.children = [...level1.children].reverse();
          }
        });

        this.options = options;
        /*this.orgId=JSON.parse(sessionStorage.getItem("userId"));*/
      });
    },
    getStation() {
      post(url.getStation, {
        matchId: this.listMatches[this.listMatches.length - 1].id,
      }).then((res) => {
        this.stationData = res.list;
      });
    },
    getTypes(parms, index) {
      for (let item of this.stationData) {
        if (item.id == parms) {
          this.firstClass[index].form.substationNameInfo = item.name;
          break;
        }
      }
      post(url.getTypes, { substationId: parms }).then((res) => {
        this.firstClass[index].typesData = res.list;
      });
    },
    getClass(parms, index) {
      for (let item of this.firstClass[index].typesData) {
        if (item.id == parms) {
          this.firstClass[index].form.levelCategoryNameInfo = item.categoryName;
          break;
        }
      }
      this.firstClass[index].form.testLevelInfo = "";
      post(url.getClass, { LevelCategoryId: parms }).then((res) => {
        this.firstClass[index].classData = res.list;
      });
    },
    changeClass(parms, index) {
      for (let item of this.firstClass[index].classData) {
        if (item.id == parms) {
          this.firstClass[index].form.testLevelNameInfo = item.name;
          break;
        }
      }
    },
    querySearch(queryString, cb) {
      if (queryString) {
        let testType = this.firstClass[this.classIndex].typesData;
        let testLevel = this.firstClass[this.classIndex].classData;
        this.firstClass[this.classIndex].tableData[this.typeIndex].genderInfo =
          "";
        this.firstClass[this.classIndex].tableData[
          this.typeIndex
        ].personNameInfo = "";
        this.firstClass[this.classIndex].tableData[
          this.typeIndex
        ].credentialsTypeInfo = "";
        this.firstClass[this.classIndex].tableData[
          this.typeIndex
        ].personIdInfo = "";
        post(url.searchPlayer, {
          credentialsNo: queryString,
          testType: testType,
          testLevel: testLevel,
          type: 1,
        }).then((res) => {
          if (res.message === "无运动员信息" || res.data.length == 0) {
            this.$nextTick(function () {
              // this.firstClass[this.classIndex].tableData[this.typeIndex].notAllowChange = false;
              this.$set(
                this.firstClass[this.classIndex].tableData[this.typeIndex],
                "notAllowChange",
                false
              );
              this.$set(
                this.firstClass[this.classIndex].tableData[this.typeIndex],
                "canUpdateBirthday",
                true
              );
              cb(this.result);
              this.$message({
                message: "无符合筛选条件运动员",
                type: "warning",
              });
            });
          } else {
            if (
              this.firstClass[this.classIndex].form.value[1].indexOf(
                "冰上舞蹈"
              ) != -1
            ) {
              this.libraryData = this.filterGender(res.data) || [];
            } else {
              this.libraryData = res.data || [];
            }
            if (!this.libraryData.length) {
              this.$message({
                message: "无符合筛选条件运动员",
                type: "warning",
              });
            }
            for (let i of this.libraryData) {
              let personNameInfo = i.personNameInfo;
              let oldLvId = i.oldLvId ? i.oldLvId : "";

              let dealCodeId = "";
              if (i.personIdcodeInfo.length == 18) {
                //处理身份证****
                let newArr = i.personIdcodeInfo.split("");
                newArr.splice(6, 9, "*******");
                dealCodeId = newArr.join("");
              } else {
                let newArr = i.personIdcodeInfo.split("");
                newArr.splice(3, 4, "*******");
                dealCodeId = newArr.join("");
              }
              let personIdcodeInfo = i.personIdcodeInfo
                ? "(" + dealCodeId + ")"
                : "(未登记身份信息)";
              i.value = personNameInfo + personIdcodeInfo + oldLvId; //将想要展示的数据作为value
            }
            cb(this.libraryData);
          }
        });
      } else {
        cb(this.result);
      }
    },
    filterGender(data) {
      let antherIndex =
        this.typeIndex % 2 ? this.typeIndex - 1 : this.typeIndex + 1; //另一个舞伴的index
      console.log(this.firstClass[this.classIndex].tableData[antherIndex]);
      let antherGender =
        this.firstClass[this.classIndex].tableData[antherIndex].genderInfo; //另一个舞伴的性别
      let backDatas = data.filter((item, index) => {
        return item.genderInfo != antherGender;
      });
      return backDatas;
    },
    handleSelect(item) {
      if (item.credentialsTypeInfo == "0") {
        item.credentialsTypeInfo = "";
      }
      item.orgName = this.clubName;
      let appobj = item.personIdcodeInfo
        ? {
            orgId: this.orgId,
            matchId: this.listMatches[this.listMatches.length - 1].id,
            notAllowChange: true,
            canUpdateBirthday: !item.birthday,
          }
        : {
            orgId: this.orgId,
            matchId: this.listMatches[this.listMatches.length - 1].id,
          };
      Object.assign(
        this.firstClass[this.classIndex].tableData[this.typeIndex],
        item,
        this.firstClass[this.classIndex].form,
        appobj
      );
      /*item.arrangementId=this.firstClass[this.classIndex].form.selectedOptions;*/
      /*this.$set(this.firstClass[this.classIndex].tableData, this.typeIndex, item);*/
      /*this.firstClass[this.classIndex].tableData[this.typeIndex].personIdcodeInfo=item.personIdcodeInfo;
      this.firstClass[this.classIndex].tableData[this.typeIndex].personNameInfo=item.personNameInfo;
      this.firstClass[this.classIndex].tableData[this.typeIndex].genderInfo=item.genderInfo;
      this.firstClass[this.classIndex].tableData[this.typeIndex].credentialsTypeInfo=item.credentialsTypeInfo;
      this.firstClass[this.classIndex].tableData[this.typeIndex].personIdInfo=item.personIdInfo;
      this.firstClass[this.classIndex].tableData[this.typeIndex].arrangementId=this.firstClass[this.classIndex].form.arrangementId;*/
    },
    getIndex(classIndex, typeIndex) {
      this.classIndex = classIndex;
      this.typeIndex = typeIndex;
      if (!this.firstClass[this.classIndex].form.arrangementId) {
        this.$message({
          message: "请选择等级报名筛选条件",
          type: "warning",
        });
      }
      // this.querySearch('');
    },
    handleChange(value, index) {
      let isIceDance = value[1].indexOf("冰上舞蹈") != -1 ? true : false;
      this.firstClass[index].typesData = this.$refs[index][0].currentLabels[1];
      this.firstClass[index].classData = this.$refs[index][0].currentLabels[2];
      this.firstClass[index].form.arrangementId = value[2];

      if (
        this.firstClass[index].classData == "基础级" ||
        this.firstClass[index].classData == "一级"
      ) {
        //基础级
        this.firstClass[index].editOrNot = false;
        this.firstClass[index].tableData = [
          {
            personIdcodeInfo: "",
            personNameInfo: "",
            genderInfo: "",
            credentialsTypeInfo: "",
            orgId: this.orgId,
            matchId: this.listMatches[this.listMatches.length - 1].id,
            orgName: this.clubName,
            arrangementId: value[2],
            birthday: this.birthday,
            canUpdateBirthday: false, //是否允许修改生日
            notAllowChange: true,
          },
        ];
        if (this.roleType === this.RoleType.Personal) {
          this.firstClass[index].tableData = [
            {
              personIdcodeInfo: this.credentialsNo,
              personNameInfo: this.name,
              genderInfollow: this.sex ? true : false, //是否允许修改性别
              TypeInfo: this.TypeInfoTypeInfo ? true : false, //是否允许修改证件type
              genderInfo: this.sex,
              credentialsTypeInfo: this.credentialsType,
              orgId: "",
              matchId: this.listMatches[this.listMatches.length - 1].id,
              arrangementId: value[2],
              personIdInfo: this.orgId,
              birthday: this.birthday,
              canUpdateBirthday: !this.birthday, //是否允许修改生日
            },
          ];
          console.log(
            this.firstClass[index].tableData,
            "this.firstClass[index].tableData"
          );
        }
        if (isIceDance) {
          //如果是冰舞，就要选舞伴
          this.firstClass[index].tableData.push({
            personIdcodeInfo: "",
            personNameInfo: "",
            genderInfo: "",
            credentialsTypeInfo: "",
            orgId: "",
            matchId: this.listMatches[this.listMatches.length - 1].id,
            arrangementId: value[2],
            orgName: this.clubName,
            notAllowChange: false,
            birthday: "",
            canUpdateBirthday: !this.birthday, //是否允许修改生日
          });
        }
      } else {
        this.firstClass[index].editOrNot = true;
        if (this.roleType === this.RoleType.Personal) {
          //个人
          this.firstClass[index].tableData = [
            {
              personIdcodeInfo: this.credentialsNo,
              personNameInfo: this.name,
              genderInfollow: this.sex ? true : false, //是否允许修改性别
              TypeInfo: this.TypeInfoTypeInfo ? true : false, //是否允许修改证件type
              genderInfo: this.sex,
              credentialsTypeInfo: this.credentialsType,
              orgId: "",
              matchId: this.listMatches[this.listMatches.length - 1].id,
              arrangementId: value[2],
              personIdInfo: this.orgId,
              birthday: this.birthday, //是否允许修改生日
              canUpdateBirthday: !this.birthday, //是否允许修改生日
            },
          ];
        } else {
          this.firstClass[index].tableData = [
            {
              personIdcodeInfo: "",
              personNameInfo: "",
              genderInfo: "",
              credentialsTypeInfo: "",
              orgId: this.orgId,
              matchId: this.listMatches[this.listMatches.length - 1].id,
              birthday: this.birthday,
              canUpdateBirthday: !this.birthday, //是否允许修改生日
              notAllowChange: true,
            },
          ];
        }
        if (isIceDance) {
          //如果是冰舞，就要选舞伴
          this.firstClass[index].tableData.push({
            personIdcodeInfo: "",
            personNameInfo: "",
            genderInfo: "",
            credentialsTypeInfo: "",
            orgId: this.orgId,
            matchId: this.listMatches[this.listMatches.length - 1].id,
            notAllowChange: true,
            birthday: "",
            canUpdateBirthday: !this.birthday, //是否允许修改生日
          });
        }
        console.log(this.firstClass[index].tableData);
      }
    },
    judgeFull(id) {
      post(url.judgeFull, { id: id }).then((res) => {
        if (res.status == 200) {
          this.allowApply = res.data;
          if (!this.allowApply && this.roleType === this.RoleType.Visitor) {
            const h = this.$createElement;
            this.$msgbox({
              title: "完善信息",
              showClose: false,
              closeOnClickModal: false,
              message: h("p", null, [
                h("span", null, "请到账户中心完善信息 "),
                h(
                  "i",
                  {
                    style: { color: "teal", cursor: "pointer" },
                    on: { click: this.clickHandler },
                  },
                  "前往完善信息>>"
                ),
              ]),
              showCancelButton: false,
              confirmButtonText: "确定",
            }).then((action) => {
              this.clickHandler();
            });
          }
        }
      });
    },
    clickHandler() {
      this.$msgbox.close();
      this.$router.push({ path: "personal/count" });
    },
    getUserMsg() {
      let user = JSON.parse(sessionStorage.getItem("user"));
      post(url.getUserInfo, { id: user.id }).then((res) => {
        sessionStorage.setItem("type", JSON.stringify(res.account.type));
        sessionStorage.setItem(
          "userId",
          JSON.stringify(res.data ? res.data.id : "")
        );

        this.orgId = res.data ? res.data.id : "";
        this.roleType = res.account.type;
        // this.roleType=1;

        this.clubName = res.data ? res.data.name : "";

        if (this.roleType === this.RoleType.Personal) {
          //个人
          /*this.$router.push({path:'personal/orderList'})*/
          this.name = res.data.name;
          this.sex = res.data.sex;
          this.credentialsType = res.data.credentialsType; //个人证件类别
          this.credentialsNo = res.data.credentialsNo;
          this.birthday = res.data.birthday;
        }

        // if (this.roleType === this.RoleType.Visitor) {         //游客
        //   const h = this.$createElement;
        //   this.$msgbox({
        //     title: '完善信息',
        //     showClose: false,
        //     closeOnClickModal: false,
        //     message: h('p', null, [
        //       h('span', null, '请到账户中心完善信息 '),
        //       h('i', {
        //         style: { color: 'teal', cursor: 'pointer' },
        //         on: { click: this.clickHandler },
        //       }, '前往完善信息>>')
        //     ]),
        //     /*showCancelButton: true,*/
        //     confirmButtonText: '确定',
        //     /*  cancelButtonText: '取消',*/
        //   }).then(() => {
        //     this.clickHandler();
        //   });
        // }

        this.judgeFull(user.id);
        this.getGameLists();
      });
    },
    // 开始报名-跳转付款
    jumpPayWay() {
      this.loading = false;
      post(url.saveMoney, {
        ...this.signUpVal,
      }).then((res) => {
        if (res.status !== 500) {
          if (res.noPay === true) {
            this.$router.push({ path: "/index/personal/orderList" });
            setTimeout(() => {
              this.$notify({
                title: "报名成功",
                // message: "订单列表查看",
                duration: 3000,
                type: "success",
                onClose: () => {
                  // this.jumpPayWay();
                  // this.$router.push({ path: "classStatus" });
                },
              });
            }, 1000);
          } else {
            this.$router.push({
              path: "choosePayWay",
              query: { orderNo: res.orderNo, money: res.cost },
            });
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style type="text/scss" lang="scss" scoped>
/deep/ .el-input--prefix.el-input--suffix .el-input__inner {
  padding-left: 15px !important;
}

.el-input__icon.birthday-icon {
  display: none;
}

.table-box {
  margin-bottom: 20px;
}

.submit-box {
  width: 100%;
  height: 56px;
  background: #e5e5e5;
  position: fixed;
  bottom: 0;
  z-index: 9;

  .submit-content-box {
    width: 1200px;
    margin: 0 auto;

    button {
      height: 55px;
      background: #5a5cbb;
      color: #fff;
      font-size: 18px;
      font-weight: 700;
      width: 160px;
      float: right;
      border: none;
      cursor: pointer;
    }
  }
}

.search-box {
  height: 41px;
  background: #eaf8ff;
  padding-top: 10px;
  border: 1px solid #e8e8e8;
  padding-left: 25px;
  border-bottom: none;
}

.table-content {
  padding: 20px;
  border: 1px solid #e8e8e8;
}

.title-box {
  font-size: 18px;
  height: 50px;
  line-height: 50px;
  margin: 15px 0 0px;
  border-bottom: 2px solid #e8e8e8;

  .title {
    color: #5a5cbb;
    border-bottom: 2px solid #5a5cbb;
    padding: 13px 35px 13px 25px;
    font-weight: 600;
  }
}

.test-name {
  height: 40px;
  line-height: 40px;
  color: #000;
  font-size: 14px;
  background: #f6f6f6;
  padding-left: 25px;
}

//授权声明
.auth-statement {
  line-height: 2;
  text-indent: 2em;
  font-size: 14px;

  h2 {
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 20px;
  }

  em {
    font-weight: bold;
  }

  .checkbox {
    text-indent: 0;
    margin-top: 30px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/applyPage.vue